import { jsx as a, Fragment as L, jsxs as s } from "react/jsx-runtime";
import e from "./styles.module.less.js";
import N from "./logo.webp.js";
import C from "./menu-dropdown-wrapper-mobile.svg.js";
import b from "./burger.svg.js";
import $ from "./close.svg.js";
import { useState as w, useCallback as g, useMemo as I } from "react";
import { AccountLink as A } from "./account-link/index.js";
import v from "./chevron-right.svg.js";
import { DropdownMenuItemMobile as f } from "./dropdown-menu-item/index.js";
import { useDisableScroll as y } from "../../../utils/use-disable-scroll.js";
import { areasOfLawData as S } from "../../../constants.js";
import { convertToKebabCase as R } from "../../../utils/case-conversion.js";
import { getAboutLinks as O } from "./get-about-links.js";
import { MobileAccountModalLink as T } from "./mobile-account-modal/index.js";
import { MenuChatButtonMobile as D } from "./chat-button/index.js";
import { getRoute as M, RouteType as k } from "../../../utils/get-route.js";
import q from "./message-animated.svg.js";
import E from "./spark-animated-midnight.svg.js";
const ie = (i) => {
  const { isAuthenticated: l, openAuthModal: n, getTranslation: t, language: h } = i, [o, r] = w(!1);
  y({ isDisabled: o });
  const m = g(() => {
    r(!0);
  }, []), d = g(() => {
    r(!1);
  }, []), c = g(() => {
    r(!1), l || n();
  }, [l, n]), u = g(() => {
    r(!1), i.logout();
  }, [i.logout]);
  return /* @__PURE__ */ a(L, { children: /* @__PURE__ */ s(
    "div",
    {
      className: `${e.menuModalOverlay} ${o ? e.menuModalOverlayOpen : ""}`,
      children: [
        /* @__PURE__ */ a(
          W,
          {
            isMenuOpen: o,
            closeMenu: d,
            openMenu: m,
            onAccountClick: c,
            handleLogout: u,
            isAuthenticated: i.isAuthenticated,
            userImage: i.userImage,
            hasNotifications: i.hasNotifications,
            language: h,
            getTranslation: t,
            isLawyerSupported: i.isLawyerSupported
          }
        ),
        /* @__PURE__ */ a(
          x,
          {
            isAuthenticated: i.isAuthenticated,
            language: h,
            handleLogout: u,
            closeMenu: d,
            hasNotifications: i.hasNotifications,
            userImage: i.userImage,
            onAccountClick: c,
            getTranslation: t,
            isLawyerSupported: i.isLawyerSupported
          }
        ),
        /* @__PURE__ */ a(C, { className: e.mobileBGIcon })
      ]
    }
  ) });
}, W = (i) => {
  const {
    isMenuOpen: l,
    closeMenu: n,
    openMenu: t,
    onAccountClick: h,
    handleLogout: o,
    isAuthenticated: r,
    hasNotifications: m,
    userImage: d,
    language: c,
    getTranslation: u,
    isLawyerSupported: p
  } = i;
  return /* @__PURE__ */ s("div", { className: e.mobileMenuContainer, children: [
    /* @__PURE__ */ a(
      "div",
      {
        className: e.menuIconContainer,
        onClick: l ? n : t,
        children: /* @__PURE__ */ s("div", { className: e.iconWrapper, children: [
          /* @__PURE__ */ a(
            "img",
            {
              src: b,
              alt: "hamburger",
              width: 24,
              height: 24,
              className: `${e.menuIcon} ${e.defaultIcon} ${l ? e.hidden : ""}`
            }
          ),
          /* @__PURE__ */ a(
            "img",
            {
              src: $,
              alt: "close",
              width: 24,
              height: 24,
              className: `${e.menuIcon} ${e.activeIcon} ${l ? "" : e.hidden}`
            }
          )
        ] })
      }
    ),
    /* @__PURE__ */ a(
      "a",
      {
        href: c ? `/${c}` : "/",
        className: e.logoContainer,
        children: /* @__PURE__ */ a(
          "img",
          {
            src: N,
            alt: "logo",
            width: 130,
            height: 18,
            className: e.logo
          }
        )
      }
    ),
    r ? /* @__PURE__ */ a(
      A,
      {
        isAuthenticated: r,
        userImage: d,
        openAuthModal: h,
        logout: o,
        hasNotifications: m,
        closeMenuModal: n,
        language: c,
        getTranslation: u
      }
    ) : /* @__PURE__ */ a(
      D,
      {
        getTranslation: u,
        isLawyerSupported: p
      }
    )
  ] });
}, x = (i) => {
  const {
    handleLogout: l,
    language: n,
    closeMenu: t,
    onAccountClick: h,
    getTranslation: o,
    isLawyerSupported: r
  } = i, m = I(() => {
    var c;
    const d = (c = S[n]) == null ? void 0 : c.map((u) => ({
      ...u,
      path: `/${n}/${R(u.title)}`
    }));
    return d || null;
  }, [n]);
  return /* @__PURE__ */ s("div", { className: e.menuModalContent, children: [
    /* @__PURE__ */ s("div", { className: `${e.menuLinksContainer} ${e.subCategories}`, children: [
      /* @__PURE__ */ s(
        "a",
        {
          href: M(k.NEW_CHAT),
          className: `${e.mainMenuLink} ${e.askQuestionLink}`,
          onClick: t,
          children: [
            o("pages.ask-a-question"),
            /* @__PURE__ */ a(E, { className: e.sparkIcon })
          ]
        }
      ),
      r && /* @__PURE__ */ s(
        "a",
        {
          href: M(k.LAWYER_REQUEST_CHAT),
          className: `${e.mainMenuLink} ${e.requestLawyerLink}`,
          onClick: t,
          children: [
            o("pages.request-a-lawyer"),
            /* @__PURE__ */ a(q, { className: e.messageIcon })
          ]
        }
      )
    ] }),
    /* @__PURE__ */ s("div", { className: `${e.menuLinksContainer} ${e.subCategories}`, children: [
      m && /* @__PURE__ */ a(
        f,
        {
          language: n,
          titleLabel: o("pages.areas-of-law"),
          link: `/${n}/library`,
          items: m,
          classNames: {
            container: e.subMenuContainer,
            itemRow: e.offsetDropdownItemRow,
            mainMenuLink: e.mainMenuLink
          }
        }
      ),
      /* @__PURE__ */ a(
        f,
        {
          language: n,
          titleLabel: o("pages.about"),
          link: `/${n}/about`,
          items: O({ language: n, getTranslation: o }),
          classNames: {
            container: e.subMenuContainer,
            itemRow: e.offsetDropdownItemRow,
            mainMenuLink: e.mainMenuLink
          }
        }
      ),
      i.isAuthenticated ? /* @__PURE__ */ a(
        T,
        {
          language: n,
          handleLogout: l,
          userImage: i.userImage,
          hasNotifications: i.hasNotifications,
          getTranslation: o
        }
      ) : /* @__PURE__ */ s("div", { className: e.mainMenuLink, onClick: h, children: [
        o("pages.account"),
        /* @__PURE__ */ a(v, { className: e.arrowIcon })
      ] })
    ] }),
    /* @__PURE__ */ s("div", { className: e.menuLinksContainer, children: [
      n.includes("en") && /* @__PURE__ */ a(
        "a",
        {
          href: n ? `/${n}/insights` : "/insights",
          className: e.subMenuLink,
          onClick: t,
          children: o("pages.insights")
        }
      ),
      /* @__PURE__ */ a(
        "a",
        {
          href: n ? `/${n}/faqs` : "/faqs",
          className: e.subMenuLink,
          onClick: t,
          children: o("pages.faqs")
        }
      ),
      m && /* @__PURE__ */ a(
        "a",
        {
          href: n ? `/${n}/directory` : "/directory",
          className: e.subMenuLink,
          onClick: t,
          children: "Case study directory"
        }
      ),
      /* @__PURE__ */ a(
        "a",
        {
          href: n ? `/${n}/contact-us` : "/contact-us",
          className: e.subMenuLink,
          onClick: t,
          children: o("pages.contact-us")
        }
      )
    ] })
  ] });
};
export {
  ie as MobileMenu
};
